var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.00033 1.29199C3.21949 1.29199 1.29199 3.21949 1.29199 9.00033C1.29199 14.7812 3.21949 16.7087 9.00033 16.7087C14.7812 16.7087 16.7087 14.7812 16.7087 9.00033",
    stroke: "#005478",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2739 2.58685V2.58685C14.4464 1.85435 13.1822 1.93102 12.4497 2.75852C12.4497 2.75852 8.80885 6.87102 7.54635 8.29852C6.28219 9.72519 7.20885 11.696 7.20885 11.696C7.20885 11.696 9.29552 12.3569 10.5405 10.9502C11.7864 9.54352 15.4455 5.41102 15.4455 5.41102C16.178 4.58352 16.1005 3.31935 15.2739 2.58685Z",
    stroke: "#005478",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5078 3.83447L14.5036 6.48697",
    stroke: "#005478",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditicon);
export default __webpack_public_path__ + "static/media/editicon.48dedf2059ff148ef7d1df512153b670.svg";
export { ForwardRef as ReactComponent };